module.exports = __webpack_public_path__ + "img/4.7211a031.png";